import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Link } from "react-router-dom";
import ItemsAdd from "./ItemsAdd";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";

function Add(props) {
  const [bomName, setBomName] = useState("");
  //   const [selectedProduct, setSelectedProduct] = useState("");
  const [productCode, setProductCode] = useState("");
  const [machineType, setMachineType] = useState("");
  const [plantLocation, setPlantLocation] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [product, setProduct] = useState([]);
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const [unit, setunitlist] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [items, setItems] = useState([]);
  const [deletedItems, setDeletedItems] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    getPlantList();
    getProductList();
    getUnit();
    getCat();
  }, []);

  const getCat = () => {
    utils
      .callAPI("get", `/rawmaterial/category/list?page=${0}&per_page=${0}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const activeItems = res.result.filter((item) => item.status === "1");
          setCategoryList(activeItems);
        } else {
          setCategoryList([]);
        }
      })
      .catch((err) => {
        setCategoryList([]);
      });
  };

  const getUnit = () => {
    utils
      .callAPI("get", `/unit/list?page=${0}&per_page=${0}`)
      .then((res) => {
        const activeItems = res.result.filter((item) => item.status === "1");
        setunitlist(activeItems || []);
      })
      .catch(() => setunitlist([]));
  };

  const getPlantList = () => {
    utils
      .callAPI("get", `/purchaseorder/plant/list`)
      .then((res) => {
        const activeItems = res.result.filter((item) => item.status === "1");

        setPlantList(activeItems || []);
      })
      .catch(() => setPlantList([]));
  };

  const getProductList = () => {
    utils
      .callAPI("get", `/Product/list`)
      .then((res) => {
        setProductOptions(res);
      })
      .catch(() => setProductOptions([]));
  };

  const options = productOptions?.result?.map((prod) => ({
    value: prod.id,
    label: prod.productCode
      ? `${prod.product_name} - (${prod.productCode}) - ${prod?.size} ${prod?.unit?.toUpperCase() || ""}`
      : prod.product_name,
    productCode: prod.productCode,
  }));

  const handleProductSelection = (selected) => {
    setSelectedProduct(selected);
    setProductCode(selected ? selected.productCode : "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      debugger
      console.log(items)
      const rawMaterials = items.filter(
        (item) => item.label === "Raw Material" && !item.isDelete
      );
      const finishedGoods = items.filter(
        (item) => item.label === "Finished Good" && !item.isDelete
      );
      const consumableItems = items.filter(
        (item) => item.label === "Consumable Item" && !item.isDelete
      );

      // Extract deleted items
      const deletedRawMaterials = items.filter(
        (item) => item.label === "Raw Material" && item.isDelete
      );
      const deletedConsumables = items.filter(
        (item) => item.label === "Consumable Item" && item.isDelete
      );

      const deletedFinishGood = items.filter(
        (item) => item.label === "Finished Good" && item.isDelete
      );
      console.log(deletedFinishGood)
      const transformedDeletedRaw = transformDeleteItems(deletedRawMaterials);
      const transformedDeletedConsumables = transformDeleteItems(deletedConsumables);
      const delete_finish_good = transformDeleteItems(deletedFinishGood);

      // Transform the filtered data
      const transformedRawMaterials = transformItems(rawMaterials);
      const transformedFinishedGoods = transformItems(finishedGoods);
      const transformedConsumables = transformItems(consumableItems);
      const deleteItem = transformItems(deletedItems);
      var bodyFormData = new FormData();

      if (props.rowData && Object.keys(props.rowData).length > 0) {
        bodyFormData.append("id", props.rowData.id);
      }

      bodyFormData.append("bom_name", bomName);
      bodyFormData.append("product_id", selectedProduct.value);
      bodyFormData.append("product_code", productCode);
      bodyFormData.append("machine_type", machineType);
      bodyFormData.append("plant_location", plantLocation);

      // Pass data in a structured format
      bodyFormData.append(
        "bom_recipe",
        transformedRawMaterials.length > 0
          ? JSON.stringify(transformedRawMaterials)
          : ""
      );

      bodyFormData.append(
        "finish_good",
        transformedFinishedGoods.length > 0
          ? JSON.stringify(transformedFinishedGoods)
          : ""
      );

      bodyFormData.append(
        "consumable_item",
        transformedConsumables.length > 0
          ? JSON.stringify(transformedConsumables)
          : ""
      );

      bodyFormData.append(
        "delete_bom_recipe",
        transformedDeletedRaw.length !== 0
          ? JSON.stringify(transformedDeletedRaw)
          : ""
      );

       bodyFormData.append(
        "delete_finish_good",
        delete_finish_good.length !== 0
          ? JSON.stringify(delete_finish_good)
          : ""
      );

      bodyFormData.append(
        "delete_consumable_item",
        transformedDeletedConsumables.length !== 0
          ? JSON.stringify(transformedDeletedConsumables)
          : ""
      );

      utils
        .callAPI("post", `/production/bom/save`, bodyFormData)
        .then((res) => {
          if (res) {
            props.onChange({ mode: "list" });
            setIsSubmit(false);
          }
        })
        .catch(() => setIsSubmit(false));
    }
  }, [isSubmit]);

  const transformDeleteItems = (data) => {
    const currentDate = moment().format("YYYY-MM-DD");
    return data.map((info) => ({
      id: info.id ? info.id : 0,
      item_id: info.itemName,
      item_code: info.itemCode,
      qty: info.qty,
      unit_id: info.unitId,
      bom_date: currentDate,
      category: info.categoryId,
      createdBy: userProfile?.id,
    }));
  };

  const transformItems = (data) => {
    const currentDate = moment().format("YYYY-MM-DD");
    return data
      .filter((info) => info.itemName && !info.isDelete) // only include rows with an actual selection
      .map((info) => ({
        id: info.id ? info.id : 0,
        item_id: info.itemName,
        item_code: info.itemCode,
        qty: info.qty,
        unit_id: info.unitId ? info.unitId : "",
        bom_date: currentDate,
        category: info.categoryId,
        createdBy: userProfile?.id,
      }));
  };

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setisEdit(true);
      const data = props.rowData;
      const product = options?.find((a) => a?.value == data.product_id);
      setBomName(data.bom_name);
      setSelectedProduct(product);
      setProductCode(data.product_code);
      setMachineType(data.machine_type);
      setPlantLocation(data.plant_location);
      // setItems(
      //   data.bom_recipe.map((item) => {
      //     const unitObj = unit.find((u) => u.id === item.unit_id);
      //     const cat = categoryList?.find((c) => c.id === item.category);
      //     console.log(cat);
      //     return {
      //       id: item.id,
      //       itemName: item.item_id,
      //       itemCode: item?.item_code,
      //       unitId: item.unit_id,
      //       unit: item.unitName,
      //       unitId: item.unit_id,
      //       qty: item.qty,
      //       categoryId: cat?.id,
      //       categoryName: cat?.category_name,
      //     };
      //   })
      // );
    } else {
      setisEdit(false);
    }
  }, [props.rowData, productOptions]);

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header>
          <h4>Add BOM</h4>
          <div className="card-header-action">
            <Link
              className="btn btn-underline me-2"
              onClick={() => props.onChange({ mode: "list" })}
            >
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="bomName"
                    className="floating-label-fancy"
                    label="BOM Name"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter BOM Name"
                      value={bomName}
                      onChange={(e) => setBomName(e.target.value)}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mt-3">
                  <RB.FloatingLabel
                    controlId="productName"
                    className="floating-label-fancy"
                    // label="Product Name"
                  >
                    <Select
                      options={options}
                      value={selectedProduct}
                      onChange={handleProductSelection}
                      placeholder="Select Product Name"
                      className="bom-productName-select"
                      classNamePrefix="select"
                      isClearable
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="productCode"
                    className="floating-label-fancy"
                    label="Product Code"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Product Code"
                      value={productCode}
                      readOnly
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="machineType"
                    className="floating-label-fancy"
                    label="Machine Type"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Machine Type"
                      value={machineType}
                      onChange={(e) => setMachineType(e.target.value)}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    className="floating-label-fancy"
                    controlId="plantLocation"
                    label="Plant Location/Code"
                  >
                    <RB.Form.Select
                      value={plantLocation}
                      onChange={(e) => setPlantLocation(e.target.value)}
                      required
                    >
                      <option value="">Select Plant Location</option>
                      {plantList.map((plant) => (
                        <option key={plant.id} value={plant.id}>
                          {plant.plant_name}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>
            <RB.Col md={12}>
              <ItemsAdd
                items={items}
                setItems={setItems}
                isEdit={isEdit}
                setDeletedItems={setDeletedItems}
                units={unit}
                rowData={props?.rowData}
              />
            </RB.Col>
            <div className="text-end mt-3">
              <RB.Button type="submit" variant="primary" className="ms-1">
                Submit
              </RB.Button>
            </div>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
